import { render } from 'preact'
import { App } from './App.js'
import { applyPrefs, loadPrefs } from './prefs.js'
import './styles/tokens.css'
import './styles/base.css'

// Präferenzen VOR dem ersten Render setzen, sonst springt die Oberfläche für
// genau die Nutzer, die auf große Schrift angewiesen sind.
applyPrefs(loadPrefs())

render(<App />, document.getElementById('app')!)

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js')
  })
}
